/*
 * Servicio para obtener el token de ayuda desde el backend de producción
 * para que los usuarios de staging puedan acceder a la ayuda y el manual de Quantum
 */

import { Injectable } from '@angular/core';
import { CallsService } from './api/calls.service';
import { RoleManagerService } from './role-manager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HelpAuthService {

  constructor(
    private calls: CallsService,
    private roleManager: RoleManagerService,
    private http: HttpClient
  ) { }

  async getToken(): Promise<any> {
    const data = {
      pwd: 'Ayuda123$',
      usr: 'ayuda',
      tzo: -60,
      origin: this.roleManager.getOrigin(),
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: '',
      CorotaWsVersion: '0',
      CorotaSpaVersion: '',
    });

    const response: any = await this.http.post(`https://api.globaleye.es/CorotaWebService.svc/IniciarSesionUsuario`, data, { headers }).toPromise();

    if ( response && response.payload && response.payload.Token ) {
      return response.payload.Token;
    }

    return null;
  }
}
